import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllRentalLocation } from 'features/rental-location/actions';
import { Button, InputField, SelectFieldVehicleCategory, TableWrapper } from 'components/Global';
import SelectFieldShuttle from 'components/Global/SelectFieldShuttle';

import { ReactComponent as LeftArrow } from 'icons/left-arrow.svg';
import { ReactComponent as OneDayBookingIcon } from 'icons/one-day-booking-filled-icon.svg';
import { getAllCategories } from 'features/category/actions';
import { checkEmptyObject } from 'utils/functionality';
import { useAppContext } from 'components/Context/AppContext';
import {
  createOneDayBooking,
  getDetailOneDayBooking,
  updateOneDayBooking,
} from 'features/one-day-booking-surcharge/actions';
import { useLocation } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { resetSelectedOneDayBooking } from 'features/one-day-booking-surcharge/slice';
import { trackEvent } from 'utils/analytics';

const initialValue = {
  fee_amount: 0,
  locations: '',
  categories: [],
};

const DetailOneDayBooking = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const pathName = location.pathname.split('/')[2];

  const { showToast, setShowSpinner } = useAppContext();

  const { data: rentalLocationData } = useSelector((state) => state.rentalLocation);
  const { data: categoriesData } = useSelector((state) => state.category);
  const { isLoading, selectedOneDayBooking } = useSelector((state) => state.oneDayBooking);

  const [oneDayBookingSurchargeData, setOneDayBookingSurchargeData] = useState(initialValue);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [categoryValue, setCategoryValue] = useState('');
  const [searchParams] = useSearchParams();

  const id = searchParams.get('id');

  const numberInputOnWheelPreventChange = (e) => {
    e.target.blur();
    e.stopPropagation();

    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  const actionFunction = async (method, payload, successMessage, errorMessage, id) => {
    try {
      if (method === 'ADD') {
        trackEvent('one_day_booking_surcharge_created', { source: 'detail_one_day_booking' });
        await dispatch(createOneDayBooking(payload)).unwrap();
      } else {
        trackEvent('one_day_booking_surcharge_updated', { id, source: 'detail_one_day_booking' });
        await dispatch(updateOneDayBooking({ id, payloadData: payload })).unwrap();
      }
      showToast({ type: 'success', message: successMessage });
      navigate('/one-day-booking-surcharge');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      showToast({ type: 'error', message: errorMessage });
    }
  };

  const handleLokasiSewa = (location) => {
    setOneDayBookingSurchargeData({ ...oneDayBookingSurchargeData, locations: location });
  };

  const handleValueInput = (e) => {
    setOneDayBookingSurchargeData({ ...oneDayBookingSurchargeData, fee_amount: +e.target.value });
  };

  const handleSearchCategory = (value) => {
    setCategoryValue(value);

    setTimeout(() => {
      dispatch(getAllCategories({ page: 1, limit: 100, showVehicle: true, search: value }));
    }, 300);
  };

  const handleSelectedCategory = (category) => {
    const categoriesId = category.map((item) => item.id);

    setSelectedCategory(category);
    setOneDayBookingSurchargeData({ ...oneDayBookingSurchargeData, categories: categoriesId });
  };

  const submitHandler = async () => {
    const validLocation = oneDayBookingSurchargeData.location !== '' || checkEmptyObject(oneDayBookingSurchargeData);
    const validCategories = oneDayBookingSurchargeData.categories.length !== 0;
    const validFeeAmount = oneDayBookingSurchargeData.fee_amount !== 0 || oneDayBookingSurchargeData.fee_amount !== '';

    if (!validLocation) {
      return showToast({ type: 'error', message: 'Pilih Lokasi!' });
    } else if (!validCategories) {
      return showToast({ type: 'error', message: 'Pilih Catgory Mobil!' });
    } else if (!validFeeAmount) {
      return showToast({ type: 'error', message: 'Masukan Charge Tambahan!' });
    }

    const payload = {
      ...oneDayBookingSurchargeData,
      locations: [oneDayBookingSurchargeData.locations.id],
    };

    if (pathName === 'edit' && id) {
      actionFunction(
        'UPDATE',
        payload,
        'Berhasil Update One Day Booking Surcharges!',
        'Gagal Update One Day Booking Surcharges!',
        id,
      );
    } else {
      actionFunction(
        'ADD',
        payload,
        'Berhasil Membuat One Day Booking Surcharges!',
        'Gagal Membuat One Day Booking Surcharges!',
      );
    }
  };

  useEffect(() => {
    dispatch(resetSelectedOneDayBooking());
    dispatch(getAllRentalLocation());
    dispatch(getAllCategories({ page: 1, limit: 100, showVehicle: true }));

    if (pathName !== 'add-item') {
      dispatch(getDetailOneDayBooking(id));
    }

    return () => {
      dispatch(resetSelectedOneDayBooking());
    };
  }, []);

  useEffect(() => {
    if (checkEmptyObject(selectedOneDayBooking) || checkEmptyObject(categoriesData)) return;

    const newOneDayBookingSurchargesData = {
      fee_amount: selectedOneDayBooking.fee_amount,
      locations: selectedOneDayBooking.locations[0],
      categories: selectedOneDayBooking.categories.map((item) => item.id),
    };

    const selectedCategories = categoriesData.category
      .filter((item) => {
        for (let child of selectedOneDayBooking.categories) {
          if (child.id === item.id) {
            return { ...item, checked: true };
          }
        }
      })
      .map((item) => ({ ...item, checked: true }));

    setOneDayBookingSurchargeData(newOneDayBookingSurchargesData);
    setSelectedCategory(selectedCategories);
  }, [selectedOneDayBooking, categoriesData]);

  useEffect(() => {
    if (isLoading) {
      setShowSpinner(true);
    } else {
      setShowSpinner(false);
    }
  }, [isLoading]);

  return (
    <div className="detail-one-day-booking">
      <header className="detail-one-day-booking__header" onClick={() => navigate(-1)}>
        <LeftArrow />
        <p>Kembali</p>
      </header>

      <TableWrapper
        title={'One-Day Booking Surcharge'}
        icon={<OneDayBookingIcon fill="#009EF7" width="25px" height="25px" />}
      >
        <div className="detail-one-day-booking__body">
          <h3 className="title">Set One-Day Booking Surcharge</h3>
          <form className="form">
            <SelectFieldShuttle
              label="Lokasi Sewa"
              htmlFor="lokasi-sewa"
              data={rentalLocationData}
              placeholder="Masukan Lokasi Sewa"
              value={oneDayBookingSurchargeData.locations?.id}
              onChange={handleLokasiSewa}
              searchFeature
              disable={pathName === 'detail'}
            />

            <SelectFieldVehicleCategory
              label={'Kategori Mobil'}
              data={categoriesData}
              placeholder={'Cari Mobil..'}
              selectedCategory={selectedCategory}
              onSelectCategory={handleSelectedCategory}
              categoryValue={categoryValue}
              onSearchAction={handleSearchCategory}
              disable={pathName === 'detail'}
            />

            <InputField
              type="number"
              label={'Charge Tambahan'}
              placeholder={
                oneDayBookingSurchargeData.locations ? `${oneDayBookingSurchargeData.locations.currency} 0` : 'IDR 0'
              }
              value={oneDayBookingSurchargeData.fee_amount || ''}
              onChange={handleValueInput}
              onWheel={numberInputOnWheelPreventChange}
              disable={pathName === 'detail'}
            />

            <div className="submit-button">
              <Button
                width={253}
                height={50}
                role="button"
                variant="outline"
                type="button"
                onClick={() => navigate(-1)}
              >
                Kembali
              </Button>

              {pathName !== 'detail' && (
                <Button width={253} height={50} role="button" type="button" onClick={submitHandler}>
                  Simpan
                </Button>
              )}
            </div>
          </form>
        </div>
      </TableWrapper>
    </div>
  );
};

export default DetailOneDayBooking;
